"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionUser_1 = require("../../../../../../shared/components/table_actions/TableActionUser");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var TableActionMail_1 = require("../../../../../../shared/components/table_actions/TableActionMail");
var TableActionFlag_1 = require("../../../../../../shared/components/table_actions/TableActionFlag");
var TableActionSms_1 = require("../../../../../../shared/components/table_actions/TableActionSms");
var BrandsList = /** @class */ (function (_super) {
    __extends(BrandsList, _super);
    function BrandsList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDescriptionInput = null;
        _this.searchTitleInput = null;
        return _this;
    }
    BrandsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
            searchTitleFilter: [],
            searchTitleValue: "",
        }, function () {
            _this.props.data.LoadData();
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    BrandsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandsList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData();
            });
        }
    };
    BrandsList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetBrandIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u0440\u0435\u043D\u0434 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u0440\u0435\u043D\u0434 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    BrandsList.prototype.onClearDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [], searchDescriptionValue: "" });
    };
    BrandsList.prototype.onChangeDescriptionFilter = function (e) {
        this.setState({ searchDescriptionValue: e.target.value });
    };
    BrandsList.prototype.onConfirmDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [this.state.searchDescriptionValue] });
    };
    BrandsList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    BrandsList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    BrandsList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    BrandsList.prototype.getColumns = function () {
        var _this = this;
        var _description_filter = this.state.searchDescriptionFilter;
        var _title_filter = this.state.searchTitleFilter;
        return [{
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                }
            }, {
                title: 'Идентификатор',
                dataIndex: this.props.data.dk_brand_identity,
                key: this.props.data.dk_brand_identity,
                width: 150
            }, {
                title: 'Метка новых игроков',
                dataIndex: this.props.data.dk_new_usr_player_tag_title,
                key: this.props.data.dk_new_usr_player_tag_title,
                align: "center",
                width: 160
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать бренд", text: "Да" }, unlockedTexts: { menu: "Разблокировать бренд", text: "Нет" }, record: { key: record.key, title: record.title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 150,
            }, {
                title: 'Доступен',
                dataIndex: this.props.data.dk_allowed_admins_count,
                key: this.props.data.dk_allowed_admins_count,
                width: 120,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.allowed_admins_count,
                        " \u0430\u0434\u043C."));
                }
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044E", value: _this.state.searchDescriptionValue, onChange: _this.onChangeDescriptionFilter.bind(_this), onPressEnter: function () { _this.onConfirmDescriptionFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmDescriptionFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearDescriptionFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _description_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.description.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionUser_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F", onClick: function () { _this.onConfigBrandAccessClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditBrandClick(record); } }),
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigBrandGatewaysClick(record); } }),
                    React.createElement(TableActionMail_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C SMTP", onClick: function () { _this.onConfigBrandSMTPClick(record); } }),
                    React.createElement(TableActionSms_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C SMS", onClick: function () { _this.onConfigBrandSMSClick(record); } }),
                    React.createElement(TableActionFlag_1.default, { hint: "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438", onClick: function () { _this.onTranslateClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteBrandClick(record); } }))); },
                width: 120
            }];
    };
    ;
    BrandsList.prototype.onTranslateClick = function (record) {
        if (this.props.onLocalesListClick) {
            this.props.onLocalesListClick(record);
        }
    };
    BrandsList.prototype.onConfigBrandSMTPClick = function (record) {
        if (this.props.onSMTPConfigClick) {
            this.props.onSMTPConfigClick(record);
        }
    };
    BrandsList.prototype.onConfigBrandSMSClick = function (record) {
        if (this.props.onSMSConfigClick) {
            this.props.onSMSConfigClick(record);
        }
    };
    BrandsList.prototype.onConfigBrandGatewaysClick = function (record) {
        if (this.props.onGatewaysConfigClick) {
            this.props.onGatewaysConfigClick(record);
        }
    };
    BrandsList.prototype.onEditBrandClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BrandsList.prototype.onConfigBrandAccessClick = function (record) {
        if (this.props.onAccessConfigClick) {
            this.props.onAccessConfigClick(record);
        }
    };
    BrandsList.prototype.onDeleteBrandClick = function (record) {
        this.props.data.DeleteBrand(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0411\u0440\u0435\u043D\u0434 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BrandsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.props.data.LoadData(function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    BrandsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData();
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    BrandsList.prototype.bool2Str = function (val) {
        if (val) {
            return "Да";
        }
        else {
            return "Нет";
        }
    };
    BrandsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                        React.createElement("div", { style: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                flexWrap: "nowrap"
                            } },
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                                " [",
                                record.key,
                                "] "),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D"),
                                " : [",
                                record.date_added.format(_this.props.state.getDateTimeFormat()),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D"),
                                " : [",
                                record.date_changed.format(_this.props.state.getDateTimeFormat()),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0420\u0443\u0447\u043D\u043E\u0435 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435"),
                                " : [",
                                _this.bool2Str(record.is_manual_deposit),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0420\u0443\u0447\u043D\u043E\u0435 \u0441\u043D\u044F\u0442\u0438\u0435"),
                                " : [",
                                _this.bool2Str(record.is_manual_withdraw),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "C\u043D\u044F\u0442\u0438\u0435 \u0434\u043B\u044F \u043D\u0435\u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432"),
                                " : [",
                                _this.bool2Str(record.is_not_verifed_players_can_withdraw),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041C\u0430\u043A\u0441 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0447\u0435\u0440\u0435\u0437 \u043F\u0440\u043E\u043C\u043E, \u043C\u0438\u043D "),
                                " : [",
                                record.promo_can_override_partner_minutes,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0414\u043E\u043C\u0435\u043D \u0434\u043B\u044F \u0440\u0435\u0434\u0438\u0440\u0435\u043A\u0442\u0430 "),
                                " : [",
                                record.redirect_domain,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C UI \u0448\u043B\u044E\u0437 "),
                                " : [",
                                record.is_use_ui_paygws,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0422\u0435\u043B\u0435\u0433\u0440\u0430\u043C \u043A\u0430\u043D\u0430\u043B "),
                                " : [",
                                record.tg_channel,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "Email \u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 "),
                                " : [",
                                record.email_support,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "Email \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 "),
                                " : [",
                                record.email_security,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0411\u043B\u043E\u0433 "),
                                " : [",
                                record.blog_url,
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0412\u0441\u0435 \u0441\u0442\u0440\u0430\u043D\u044B \u0432 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 "),
                                " : [",
                                _this.bool2Str(record.is_all_country),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u043D\u044B\u0439 \u0431\u043E\u043D\u0443\u0441 "),
                                " : [",
                                _this.bool2Str(record.is_auto_activate_dep_bonuses),
                                "]")),
                        React.createElement("div", null,
                            React.createElement("img", { style: { marginLeft: "20px" }, height: 110, src: "" + _this.props.data.DATA.cdn_baseurl + record.cms_image_url }))));
                }, scroll: { x: true } })));
    };
    return BrandsList;
}(React.Component));
exports.default = BrandsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/BrandsList.tsx
// module id = 1751
// module chunks = 0